import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	newTabIconDescription: {
		id: 'project-settings-apps-issue-type-page-product-features.common.new-tab-link.new-tab-icon-description',
		defaultMessage: 'This link will be opened in a new tab',
		description:
			'Accessibility text to let screen reader user know that the link will be opened in a new tab',
	},
});
